<template>
  <app-dropdown
    class="account-dropdown"
    transition="translate-fade-down"
    v-model="showDropdown"
    :hover="true"
  >
    <div class="dropdown-toggle">
      <div class="dropdown-toggle__img">
        <img :src="MockImage" alt="" />
      </div>
      <div class="dropdown-toggle__right">
        <p>My Account</p>
      </div>
    </div>

    <template #dropdown>
      <dropdown-list></dropdown-list>
    </template>
  </app-dropdown>
</template>

<script setup>
import MockImage from '/images/50x50.png'
import AppDropdown from '@modules/ui/app-dropdown.vue'
import DropdownList from './dropdown-list.vue'
import { ref } from 'vue'

const showDropdown = ref(false)
</script>

<style></style>
